/**
 * @desc 我购买的
 */
import {
  PageAuctionMemberPageItem,
  AuctionMemberPageParam
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAuctionMemberPurchasePageParameter = AuctionMemberPageParam

const method = 'GET'
const url = '/trade/member/auction/purchase/page'

export const queryAuctionMemberPurchasePageApi = (
  params?: QueryAuctionMemberPurchasePageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageAuctionMemberPageItem>({
    method,
    url,
    params,
    ...config
  })
}

queryAuctionMemberPurchasePageApi.method = method
queryAuctionMemberPurchasePageApi.url = url
